<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'InfoLabel',
  mixins: [baseMixin],
  props: {
    label: {
      type: String,
      default: '',
    },
  },
}
</script>

<template>
  <div class="d-flex flex-column">
    <slot name="label" :label="label">
      <label
        :class="[
          $style.infoLabelStyling,
          ' text-body-1 pl-2 font-weight-medium',
        ]"
      >
        {{ label }}
      </label>
    </slot>

    <slot></slot>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.infoLabelStyling {
  display: block;
  line-height: 25px;
  transform-origin: top left;
}
</style>
